import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import DoneIcon from "@mui/icons-material/Done";
import { ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import { putAction, getAction } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { DateInput, IntInput, TextInput } from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import Button from "components/CustomButtons/Button.js";

import { action as actionVar } from "variables/action";

export default function EngineeringstudyEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newResults, setNewResults] = useState({});


  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewResults((prevState) => ({
      ...prevState,
      [params]: { ...prevState.results, [name]: value },
    }));
  };

  useEffect(() => {

    setNewResults(action?.parameters || {});
  }, [action]);

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionResults(event);
  };

  const createActionResults = async (event) => {
    console.log(newResults);

    axios
      .put(url, newResults, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setAction((prevState) => ({
            ...prevState,
            parameters: newResults,
          }));
          setNotification("success", "Résultats modifiée");
          getActionData();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const getActionData = () => {
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setAction(response.data || []);
        setNewResults(response.data.parameters || {});
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <DateInput
            inputTitle={actionVar[params]["validationdate"]}
            dateInput={newResults?.[params]?.["validationdate"] || ""}
            handleDateInputChange={handleChange}
            name="validationdate"
            disabled={!actionplanupdate}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params]["validatedby"]}
            textInput={newResults?.[params]?.["validatedby"] || ""}
            handleTextInputChange={handleChange}
            name="validatedby"
            disabled={!actionplanupdate}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <IntInput
            inputTitle={actionVar[params]["cost"]}
            intInput={newResults?.[params]?.["cost"] || ""}
            handleIntInputChange={handleChange}
            name="cost"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
      <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params]["comments"]}
            textInput={newResults?.[params]?.["comments"] || ""}
            handleTextInputChange={handleChange}
            name="comments"
            multiline
            rows={4}
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7} style={{
            marginTop: "15px",
            marginLeft: "8px",
          }}>
            <EditButton
              handleSubmit={handleSubmit}
              style={{
                marginTop: "15px",
                marginLeft: "8px",
              }}
            >
              Modifier
            </EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
